import { createSvgIcon } from './createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M12 5.99 19.53 19H4.47zM12 2 1 21h22z"></path>
    <path d="M13 16h-2v2h2zm0-6h-2v5h2z"></path>
  </>,
  'WarningAmber',
)
